import { useState } from 'react';

export const draftKey = (user, contact) => contact ? `what-mobile:draft:${user}:${contact.connection || 'legacy'}:${contact.id}` : '';
export function readDraft(key) {
  try { return key ? localStorage.getItem(key) || '' : ''; } catch (_) { return ''; }
}
export default function useChatDraft(user, contact) {
  const key = draftKey(user, contact);
  const [draft, update] = useState({ key, text: readDraft(key) });
  const text = draft.key === key ? draft.text : readDraft(key);
  const setText = value => {
    const next = typeof value === 'function' ? value(text) : value;
    try { if (key) { if (next) localStorage.setItem(key, next); else localStorage.removeItem(key); } } catch (_) { /* Memory draft remains usable. */ }
    update({ key, text: next });
  };
  return [text, setText];
}
